import { BaseFadeTransition } from './BaseFadeTransition';

export class CrossFadeTransition extends BaseFadeTransition {

    getDisplayName() {
        return 'Vervagen in volgende media';
    }

    shouldWaitForTransitionEnd() {
        return false;
    }
}
